<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <button id="printButton" v-show="printShow" v-on:click="onPrintButtonClick" type="button" class="btn btn-warning" style="float:right">
        Print
      </button>

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput" >

        <div
          slot="jt-form-slot-sectionProductSubscription">
          <PagePLAddOnFormLease
            ref="pageTableLease"
            v-on:lease-season-select="onApplicationLeaseSelect"
            v-on:lease-season-remove="onApplicationLeaseRemove"
            v-on:lease-parker-add="onApplicationParkerAdd" />
        </div>

        <div
          slot="jt-form-slot-sectionApproval"
          class="table-responsive"
          v-show="approvalItem.length">
          <h3>Available Bay Summary</h3>
          <hr>
          <table
            class="table table-bordered"
            ref="pageTableApproval" >
            <tr>
              <th>Product</th>
              <th>Available Bays</th>
              <th>Application Requested Bays</th>
              <th>Summary</th>
            </tr>
            <tr v-for="item of approvalItem" v-bind:key="'requested_' + item.product" v-bind:style="item.status === 'OK' ? 'background-color:#dbffdb' : 'background-color:#ffb4aa'">
              <td>{{item.product}}</td>
              <td>{{item.available}}</td>
              <td>{{item.request}}</td>
              <td>{{item.status}}</td>
            </tr>
          </table>
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <div id="button-bottom">
        
        <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
          Cancel
        </button>

        <TemplateButton v-show="hasAddPermission() && pageShowAdd && pageCanAdd && approvalNotLoading" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
          Submit Application
        </TemplateButton>

        <TemplateButton v-show="hasEditPermission() && pageShowEdit && pageCanEdit && approvalNotLoading" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
          Submit Application
        </TemplateButton>

        <div class="btn-group" v-show="(hasApprovePermission() || hasRejectPermission() || hasVoidPermission()) && approvalShow && approvalNotLoading">
          <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Approval Action
          </button>
          <div class="dropdown-menu">
            <a v-show="hasApprovePermission() && approvalShowApprove" class="dropdown-item" href="#" v-on:click.prevent="onApplicationApproveClick" >Approve Application</a>
            <a v-show="hasRejectPermission() && approvalShowReject" class="dropdown-item" href="#" v-on:click.prevent="onApplicationRejectClick" >Reject Application</a>
            <a v-show="hasApprovePermission() && approvalShowPending" class="dropdown-item" href="#" v-on:click.prevent="onApplicationPendingClick" >Pending Approval</a>
            <a v-show="hasVoidPermission() && approvalShowVoid" class="dropdown-item" href="#" v-on:click.prevent="onApplicationVoidClick" >VOID Application</a>
          </div>
        </div>

        <TemplateButton v-show="false && pageShowPaid" v-on:click="onApplicationPaidClick" type="button" class="btn btn-danger">
          PAID
        </TemplateButton>
        
      </div>
      
      <AppModalForm 
        ref="pageApprovalModal" 
        v-bind:formParameter="[]"
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <div>
          {{ approvalText }}
        </div>
        <div v-show="approvalReject">
          <br>
          <label>{{ approvalRejectLabel }}</label>
          <input class="form-control" v-model="approvalRejectReason">
          <label class="error form-control-feedback">{{approvalRejectReasonError}}</label>
        </div>
        <TemplateButton slot="modal-footer-after" @click="pageApprovalModalConfirm" type="button" class="btn btn-success">
          Confirm
        </TemplateButton>
      </AppModalForm>

      <AppModalForm 
        ref="parkerModal" 
        v-bind:formParameter="PARKER_PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onParkerModalAddDataClick"
        v-bind:modalShowEdit="false"
        v-bind:modalShowDelete="false" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLAddOnFormLease from "@/components/Page/ParkingLicense/PagePLAddOnFormLease2";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => {
        let option = data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name;
        if(data._disabled) {
          option += ' (' + data._disabled + ')';
        }
        return option;
      },
      formatSelectOptionAttr: (data) => data._disabled ? {disabled: 1} : {},
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationCarparkTenant',
    text: 'Car Park Tenant',
    form_invalid: true,
    form_radio: [{1:'Yes'}, {0:'No'}],
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: '_commencementDate',
    text: 'Commencement Date',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: 'paymentPlan',
    text: 'Payment Plan',
    form_radio: [
      {1:'Monthly'}, 
      {2:'Quarterly'},
      {3:'Half-Year'},
      {4:'Annually'}
    ],
  },
  {
    key: 'totalPayable',
    text: 'Total Amount Payable (RM)',
    form_input_attr: {
      disabled: true,
    },
    form_input_validation: []
  },
  {
    key: 'sectionBilling',
    form_section: 'Billing & Correspondence Instructions',
  },
  {
    key: 'accessCard',
    text: 'Deliver Parking Access Card to:',
    form_hide: true,
    form_radio: ['Correspondence Address', 'Company Address'],
    form_default: 'Correspondence Address',
    form_input_validation: []
  },
  {
    key: 'agreeEmailBill',
    text: 'I agree that all my bills will be sent to my email address',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'agreeEmailCorrespondences',
    text: 'I authorize that all correspondences will be sent to my email address',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionApproval',
    form_html: () => '',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

const PARKER_PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'name',
    text: 'Parker Full Name',
    table_popup: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'mobile',
    text: 'Mobile No.',
    form_phone: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_input_attr: {
      placeholder: '60XXXXXXXXX',
    },
  },
  {
    key: 'car1',
    text: 'Car Plate',
  },
  {
    key: 'email',
    text: 'Email',
    form_email: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
];

export default {
  name: "PagePLAddOnForm2",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    AppModalForm,
    PagePLAddOnFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Add On Application', url: '/plAddOn' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,
      PARKER_PARAM,

      pageTitle: null,
      pageApplication: null,
      pageShowData: false,
      pageShowAdd: false,
      pageCanAdd: false,
      pageShowEdit: false,
      pageCanEdit: false,

      pageCarpark: null,
      pageCarparkSeason: undefined,
      pageZone: undefined,
      pageCustomer: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      printShow: false,
      approvalShow: false,
      approvalShowApprove: false,
      approvalShowReject: false,
      approvalShowPending: false,
      approvalShowVoid: false,
      pageShowPaid: false,
      approvalNotLoading: true,

      pageCustomerCompany: null,
      pageCustomerPersonal: null,

      approvalItem: [],

      approvalText: null,
      approvalReject: false,
      approvalRejectLabel: 'Reason',
      approvalRejectReason: null,
      approvalRejectReasonError: null,

      setParkerAtIndexWithAddParkerModalData: null,
    }
  },
  mounted() {
    this.permission = this.$route.path.includes('Force') ? 'secretadmin' : helper.getPermission(this)
    if(!helper.hasViewPermission(this.permission)) {
      return;
    }
    
    if(!this.$route.path.includes('Force')) {
      this.$nextTick(() => {
        helper.setSidebar('/plAddOn');
      });
    }

    this.hideFormFromKey('licenseID');
    this.loadTenant();
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }
      
      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'accessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load customer, tenant, carpark & zone
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadTenant() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading tenant data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/tenant',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageTenant = response.data;
          this.loadEntitlement();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'tenant data'));
        });
    },
    loadEntitlement() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading entitlement data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/entitlement',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageEntitlement = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'entitlement data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          if(this.$refs['pageForm'].formIsAdd) {
            let keepInSelection = true;
            response.data = response.data.filter(k => {
              if(!k['isEnable']) {
                k['_disabled'] = 'Disabled';
                return keepInSelection;
              }
              if(k['SuspendApplication']) {
                k['_disabled'] = 'Suspended';
                return keepInSelection;
              }
              if(k['startDate'] && moment(k['startDate']) > moment()) {
                k['_disabled'] = 'Not Started';
                return keepInSelection;
              }
              if(k['endDate'] && helper.parseDateTime(k['endDate']) <= moment().startOf('day')) {
                k['_disabled'] = 'Stopped';
                return keepInSelection;
              }
          
              k['_disabled'] = null;
              return true;
            });
          }

          // helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark = response.data);
          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },
    
    loadApplication() {
      let applicationID = this.$route.query.applicationID;
      if(applicationID) {
        let feedbackItem = 'parking license add-on application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/request?carparkID=' + this.$route.query.carparkID + '&applicationID=' + applicationID + '&type1=addon',
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            response.data = response.data.filter(k => k.createDate > 1545955200);

            let temp = response.data[0];
            let application = {};
            application['licenseID'] = temp['licenseID'];
            application['applicationID'] = temp['applicationID'];
            application['carparkID'] = temp['carparkID'];
            application['customerID'] = temp['customerID'];
            application['paymentPlan'] = temp['paymentPlan'];
            application['_commencementDate'] = helper.formatDate(temp['commencementDate']);
            application['status'] = temp['status2'];
            application['agreeEmailBill'] = 1;
            application['agreeEmailCorrespondences'] = 1;
            application['lease'] = response.data;

            response.data.forEach(k => k['isParkAide'] = parseInt(k['isParkAide']));


            this.$refs['pageForm'].setForm(false, application);
            this.$refs['pageTableLease'].setLeaseData(application['lease'], false);

            // status = 0 -> display "Pending approval"
            // status = 1 -> display "Pending initial payment"
            // status = 2 -> display "Active"
            // status = 3 -> display "Rejected"
            // status = 4 -> display "VOID"

            this.printShow = true;

            // TODO kw1 show/hide approval action based on status
            if(application['status'] === 'Pending Approval' || application['status'] === 'Pending') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = true;
                this.approvalShowPending = false;
                this.approvalShowVoid = true;
                this.pageCanEdit = true;
            } else if(application['status'] === 'Pending Initial Payment') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = false;
                this.approvalShowVoid = true;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};

                // TODO kw1 hardcode change status to PAID button
                this.pageShowPaid = true;
            } else if(application['status'] === 'Rejected') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = true;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            } else if(application['status'] === 'Void') {
                this.approvalShow = true;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = true;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            } else {//if(application['status'] === 'Active') {
                this.approvalShow = false;
                this.approvalShowApprove = false;
                this.approvalShowReject = false;
                this.approvalShowPending = false;
                this.approvalShowVoid = false;

                this.PARAM_MAP['_commencementDate']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['paymentPlan']['form_input_attr'] = {disabled : true};
                this.PARAM_MAP['accessCard']['form_input_attr'] = {disabled : true};
            }

            this.onApplicationTypeChange();
            this.onApplicationCarparkOrProfileChange();
            this.onApplicationCarparkTenantChange();

            this.pageTitle = 'Parking License Add-On Application ' + (this.pageApplication = helper.plFormPLAONum(application['applicationID'], application['carparkID']));
            this.pageShowData = true;

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageCanAdd = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['carparkID'] = this.$route.query.carparkID || tempData['carparkID'];
        tempData['licenseID'] = this.$route.query.licenseID || tempData['licenseID'];
        tempData['paymentPlan'] = 1;
        tempData['_commencementDate'] = helper.formatDate(moment().add(7, 'days'));

        this.pageTitle = 'Parking License Add-On Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);
        this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData.lease, true);

        this.onApplicationTypeChange();
        this.onApplicationCarparkOrProfileChange();

        if(this.$refs['pageForm'].formData['carparkID']) {
          this.onCarparkChange();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['carparkID'] + '/license/';
      }

      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            // TODO kw1 only show active license & lease
            if(this.$refs['pageForm'].formIsAdd) {
              response.data = response.data.filter(k => k.status === 'Active');
            }

            this.pageLicense = response.data;

            response.data.forEach(k => {
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            });
            response.data = response.data.filter(k => k['_customer'] ? k['_customer'].isCompany : false);

            helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
            this.hideFormFromKey('_commencementDate');

            if(!this.$refs['pageForm'].formIsAdd) {
              let license = response.data.find(k => helper.compareID(k.id, formData['licenseID']));
              formData['customerID'] = license['customerID'];
              formData['carparkID'] = license['carparkID'];
              this.$refs['pageForm'].$forceUpdate();
              this.loadLeaseData();
              return;
            }

            if(formData['licenseID']) {
              let license = response.data.find(k => helper.compareID(k.id, formData['licenseID']));
              if(license) {
                formData['customerID'] = license['customerID'];
                formData['carparkID'] = license['carparkID'];
                this.onLicenseChange();
                this.loadLeaseData();
                return;
              }
            }

            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        })
    },

    loadLeaseData() {
      if(!this.pageCarparkSeason) {
        this.loadCarparkSeasonSetting();
        return;
      }

      if(!this.pageBay) {
        this.loadBay();
        return;
      }

      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      if(this.pageCarparkSeason.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('Unable to load car park product setting');
        return;
      }

      if(this.pageSeason.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('No product available');
        return;
      }

      if(this.pageParker.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('No parker available');
        return;
      }

      this.calculateParkingFees();
    },
    loadCarparkSeasonSetting() {
      let carparkID = this.$refs['pageForm'].formData['carparkID'];
      if(!carparkID) {
        return;
      }

      this.pageCarparkSeason = [];

      let feedbackItem = 'car park season setting';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + carparkID + '/seasonSetting/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCarparkSeason = response.data[0];

          if(!this.pageCarparkSeason) {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
            return;
          }
          
          this.setCarparkSeasonApplicableDate();

          if(this.$refs['pageForm'].formIsAdd) {
            this.$refs['pageTableLease'].setLeaseParkaideForce(false);

            if(this.pageCarparkSeason['ParkaideOnly']) {
              this.$refs['pageTableLease'].setLeaseParkaideForce(true);
              this.$refs['pageTableLease'].setLeaseParkaideEnable(false);
              this.$refs['pageForm'].formData['lease'].forEach(k => k['isParkAide'] = 1);
            } else if(this.pageCarparkSeason['ParkaideEnable']) {
              this.$refs['pageTableLease'].setLeaseParkaideEnable(true);
            } else {
              this.$refs['pageTableLease'].setLeaseParkaideEnable(false);
              this.$refs['pageForm'].formData['lease'].forEach(k => k['isParkAide'] = 0);
            }
          }

          try {
            let self = this;
            commencementDateValidate = function(date) {
              if(!self.$route.path.includes('Force')) {
                if(date < moment().startOf('month').toDate()) {
                  return false;
                }
              }
              
              if(date > moment().add(2, 'M').endOf('month').toDate()) {
                return false;
              }

              let pageCarparkSeason = self.pageCarparkSeason;
              if(!pageCarparkSeason.CommencementDate1 && !pageCarparkSeason.CommencementDate2) {
                return true;
              }

              if(date.getDate() === pageCarparkSeason.CommencementDate1 || date.getDate() === pageCarparkSeason.CommencementDate2) {
                return true;
              }

              return false;
            }
            $('#jt-form-input-_commencementDate').datepicker('update');
          } catch (e) {
          }

          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparkSeasonApplicableDate() {
      let formData = this.$refs['pageForm'].formData;
      if(formData['status'] === undefined) {
        if(this.pageCarparkSeason.CommencementDate1 || this.pageCarparkSeason.CommencementDate2) {
          let date = helper.parseDateTime(formData['_commencementDate']).date();
          if(date === this.pageCarparkSeason.CommencementDate1 || date === this.pageCarparkSeason.CommencementDate2) {
            return;
          }

          let today = moment();

          if(this.pageCarparkSeason.CommencementDate1) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate1);
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate2) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate2);
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate1) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate1);
            nextApplicableDate.add(1, 'month');
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }

          if(this.pageCarparkSeason.CommencementDate2) {
            let nextApplicableDate = moment().date(this.pageCarparkSeason.CommencementDate2);
            nextApplicableDate.add(1, 'month');
            if(nextApplicableDate > today) {
              return formData['_commencementDate'] = helper.formatDate(nextApplicableDate);
            }
          }
        }
      }
    },
    loadBay() {
      this.hideFormFromKey('applicationCarparkTenant');

      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['pageForm'].formData['carparkID'];
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageBay = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeason() {
      this.hideFormFromKey('applicationCarparkTenant');

      if(this.$refs['pageForm'].formIsAdd) {
        this.$refs['pageTableLease'].setSeasonData(null);
      }

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['carparkID'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.pageSeason.forEach(k => {
              let zone = this.pageZone.find(j => j.id === k.zoneID) || {};
              k['_zone'] = zone;
              k['_zoneName'] = zone.name;
              k['_bayAvailable'] = this.pageBay.filter(j => j.seasonID === k.id && !j.leaseID).length;
            });
            this.onApplicationCarparkTenantChange();
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('paymentPlan');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            if(this.pageFees[seasonID] = response.data) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('applicationCarparkTenant');

      if(this.$refs['pageForm'].formIsAdd) {
        this.$refs['pageTableLease'].setParkerData(null);
      }

      let customerID = this.$refs['pageForm'].formData['customerID'];
      
      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;

            if(this.setParkerAtIndexWithAddParkerModalData !== null) {
              let modalParkerAddForm = this.$refs['parkerModal'].$refs['modalForm'].formData;
              let newlyAddedParker = response.data.find(j => j.name === modalParkerAddForm.name && j.email === modalParkerAddForm.email && j.car1 === modalParkerAddForm.car1) || {};
              this.$refs['pageForm'].formData['lease'][this.setParkerAtIndexWithAddParkerModalData]['parkerID'] = newlyAddedParker.id;
              this.setParkerAtIndexWithAddParkerModalData = null;
            }
            
            this.$refs['pageTableLease'].setParkerData(this.pageParker);
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['totalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let paymentPlan = parseInt(formData['paymentPlan']);
      if(paymentPlan === undefined || paymentPlan === null) {
        return;
      }

      let _commencementDateText = formData['_commencementDate'];
      if(_commencementDateText === undefined || _commencementDateText === null || _commencementDateText === '') {
        return;
      }

      let _commencementDate = helper.parseDateTime(_commencementDateText);
      let daysInMonth = _commencementDate.daysInMonth();
      let startDay = _commencementDate.date();

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let formStatus = this.$refs['pageForm'].formData.status;
      let requestedSeason = {};

      let error = false;
      let tandemCalculated = [];
      formData.lease.forEach((leaseData, leaseIndex) => {
        this.$refs['pageTableLease'].onParkerChange(leaseIndex);

        leaseData['commencementDate'] = _commencementDate.unix();
        leaseData['paymentPlan'] = paymentPlan;

        if(!leaseData['seasonID']) {
          return;
        }

        let leaseSeason = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID']));
        leaseData['leaseProduct'] = leaseSeason;
        leaseData['leaseProductZone'] = leaseSeason['_zone'];
        leaseData['leaseProductName'] = leaseSeason['name'] + ` - ${leaseSeason['_zone'].name}`;
        leaseData['seasonFeesID'] = null;

        requestedSeason[leaseData['seasonID']] = requestedSeason[leaseData['seasonID']] || {
          name: leaseData['leaseProductName'],
          entitleOnly: leaseSeason['entitleOnly'],
          count: 0,
        };
        requestedSeason[leaseData['seasonID']].count++;

        if(!this.pageFees[leaseData['seasonID']]) {
          return;
        }
        
        let product;
        let earliestFeesDate = 0;
        if(this.$refs['pageForm'].formIsAdd) {
          // get season fees based on commencement date
          product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
          if(!product) {
            for(let temp of this.pageFees[leaseData['seasonID']]) {
              if(temp.startDate <= _commencementDate.unix()) {
                product = temp;
                break;
              }
              if(!earliestFeesDate || earliestFeesDate > temp.startDate) {
                earliestFeesDate = temp.startDate;
              }
            }
          }
        } else {
          product = this.pageFees[leaseData['seasonID']].find(k => helper.compareID(k.id, leaseData['seasonFees']));
          // if(!product || product.startDate > _commencementDate.unix()) {
          if(!product) {
            product = this.pageFees[leaseData['seasonID']].find(k => k.isActive)
            if(!product) {
              for(let temp of this.pageFees[leaseData['seasonID']]) {
                if(temp.startDate <= _commencementDate.unix()) {
                  product = temp;
                  break;
                }
                if(!earliestFeesDate || earliestFeesDate > temp.startDate) {
                  earliestFeesDate = temp.startDate;
                }
              }
            }
          }
        }
        if(!product) {
          leaseData['seasonFees'] = null;
          error = true;
          if(earliestFeesDate) {
            this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(leaseData['leaseProductName'] + ' product do not have product fee at this commencement date, this product fee start on ' + helper.formatDate(earliestFeesDate));
          } else {
            this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(leaseData['leaseProductName'] + ' product do not have product fee');
          }
          $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
          return;
        }
        
        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['seasonFeesID'] = product.id;
        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(paymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['monthly'];
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['quarterly'];
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['halfYearly'];
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFeePerMonth'] = product['annually'];
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            break;
        }

        if(!error) {
          this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(null);
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          leaseData['pairID'] = leaseData['pairID'] || leaseData['data5']
          if(!leaseData['pairID'] || !tandemCalculated.includes(leaseData['pairID'])) {
            leaseTotal[k] += leaseData[k];
          }
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
        tandemCalculated.push(leaseData['pairID']);
      });

      if(!helper.checkRoleIsParker()) {
        if(formStatus === 'Pending Approval' || formStatus === 'Pending') {
          this.approvalItem = [];
          for(let requestedSeasonID in requestedSeason) {
            let requestedSeasonItem = requestedSeason[requestedSeasonID];
            let requestedBay = requestedSeasonItem.count;
            let availableBay;
            if(requestedSeasonItem.entitleOnly) {
              let entitlement = this.pageEntitlement.find(j => 
                helper.compareID(j['seasonID'], requestedSeasonID) 
                && helper.compareID(j['tenantID'], formData['tenant']['id']))
              if(!entitlement || !entitlement.bayCount) {
                availableBay = 0;
              } else {
                let usedEntitlementBay = this.pageBay.filter(j => j.seasonID === requestedSeasonID && j.leaseID && helper.compareID(j['customerID'], formData['customerID'])).length;
                availableBay = entitlement.bayCount - usedEntitlementBay;
              }
            } else {
              availableBay = this.pageBay.filter(k => helper.compareID(k.seasonID, requestedSeasonID) && !k.leaseID).length;
            }
            
            this.approvalItem.push({
              product: requestedSeasonItem['name'],
              available: availableBay,
              request: requestedBay,
              status: availableBay >= requestedBay ? 'OK' : 'NG',
            });
          }

          let ngItem = this.approvalItem.find(k => k.status === 'NG');
          if(ngItem) {
            this.$refs['pageFeedback'].setFeedbackError('Please increase Bay Count allocation in ' + ngItem.product);
            this.approvalShowApprove = false;
          } else {
            this.approvalShowApprove = true;
          }
        }
      }

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      this.$refs['pageTableLease'].$forceUpdate();

      formData['totalPayable'] = leaseTotal['leaseProductInitialPaymentText'];
      this.$refs['pageForm'].$forceUpdate();

      this.hideFormFromKey(null);
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      let url = this.$route.query.pending ? helper.WEB_URL + '/plAddOnPending' : helper.WEB_URL + '/plAddOn';
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },
    onPrintButtonClick() {
      $('#printButton').hide();
      $('#jt-form-div-sectionApproval').hide();
      $('#button-bottom').hide();
      window.print();
      $('#printButton').show();
      $('#jt-form-div-sectionApproval').show();
      $('#button-bottom').show();
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        if(this.$refs['pageForm'].formIsAdd) {
          this.addApplication({});
        } else {
          this.editApplication({});
        }
      }
    },
    onApplicationParkerAdd(index) {
      this.$refs['pageForm'].formData['lease'][index]['parkerID'] = null;
      this.$refs['parkerModal'].setModalOpen(true, 'Add New Parker', {index: index});
    },
    async onParkerModalAddDataClick(selectedData) {
      let feedbackItem = selectedData.name;

      selectedData.customerID = this.$refs['pageForm'].formData['customerID'];
      
      this.$refs['parkerModal'].setModalLoading('Adding parker ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/customer/' + selectedData.customerID + '/parker',
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['parkerModal'].setModalClose();
          this.$refs['pageForm'].formData['lease'][selectedData.index]['parkerID'] = response.data[0].id;

          this.setParkerAtIndexWithAddParkerModalData = selectedData.index;
          this.loadParker();
        })
        .catch(error => {
          this.$refs['parkerModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding parker', feedbackItem));
        })
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let lease = formData.lease;
      for(let leaseData of lease) {
        let error;
        if(!leaseData['seasonID']) {
          error = 'Please select valid product before proceed';
        } else if(!this.pageFees[leaseData['seasonID']] || !leaseData['seasonFeesID']) {
          error = 'Please select product with valid season fees before proceed';
        // } else if(!leaseData['parkerID']) {
        //   error = 'Please select valid parker before proceed';
        }

        let parkerName = leaseData['leaseParkerName'] || '';
        if(!parkerName) {
          error = error || 'Parker Name cannot be empty';
        }

        let parkerMobile = leaseData['leaseParkerMobile'] || '';
        if(!parkerMobile.startsWith('6')) {
          error = error || 'Phone number must start with 6 e.g. 60121234567';
        }
        if(parkerMobile.startsWith('6011')) {
          if(parkerMobile.length !== 12) {
            error = error || 'Phone number start with 6011 must have 12 digits e.g. 601112345678';
          }
        } else if(parkerMobile.startsWith('601')) {
          if(parkerMobile.length !== 11) {
            error = error || 'Phone number start with 601 must have 11 digits e.g. 60121234567';
          }
        }

        let parkerPlate = leaseData['leaseParkerPlate'] || '';
        if(!parkerPlate) {
          error = error || 'Parker Car Plate cannot be empty';
        }

        let parkerEmail = leaseData['leaseParkerEmail'] || '';
        if(!parkerEmail) {
          error = error || 'Parker Email cannot be empty';
        } else {
          error = error || validation.validateEmail(parkerEmail);
        }

        if(error) {
          this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError(error);
          $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
          return true;
        }
      }
      this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError();

      let selectedDate = helper.parseDateTime(formData['_commencementDate']);
      let commencementDate1 = this.pageCarparkSeason['CommencementDate1'];
      let commencementDate2 = this.pageCarparkSeason['CommencementDate2'];
      if(commencementDate1 && commencementDate2) {
        if(selectedDate.date() !== commencementDate1 && selectedDate.date() !== commencementDate2) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate1} or ${commencementDate2} of the month`);
          return true;
        }
      } else if(commencementDate1) {
        if(selectedDate.date() !== commencementDate1) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate1} of the month`);
          return true;
        }
      } else if(commencementDate2) {
        if(selectedDate.date() !== commencementDate2) {
          this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError(`Commencement date must be ${commencementDate2} of the month`);
          return true;
        }
      }
      this.$refs['pageForm'].$refs['jt-form-element-_commencementDate'][0].setInputError();

      if(!formData['agreeEmailBill'] || !formData['agreeEmailCorrespondences']) {
        this.$refs['pageForm'].$refs['jt-form-element-agreeEmailCorrespondences'][0].setInputError('To proceed you must agree to the billing and correspondence instructions.');
        return true;
      }

      if(formData['applicationType'] === 'Personal' && !formData['accessCard']) {
        this.$refs['pageForm'].$refs['jt-form-element-accessCard'][0].setInputError('Please select access card delivery option.');
        return true;
      }
    },

    isTenant() {
      let formData = this.$refs['pageForm'].formData;
      return formData['tenant'] = this.pageTenant.find(k => helper.compareID(k.carparkID, formData['carparkID']) && helper.compareID(k.customerID, formData['customerID']));
    },
    async addApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let lease = formData.lease;
      for(let leaseData of lease) {
        let temp = {};
        temp['name'] = leaseData['leaseParkerName'];
        temp['mobile'] = leaseData['leaseParkerMobile'];
        temp['car1'] = leaseData['leaseParkerPlate'];
        temp['email'] = leaseData['leaseParkerEmail'];

        let feedbackItem = 'parking license application parker';
        this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
        if(
          !await this.$http
            .post(
              helper.SERVER_URL + '/api2/customer/' + formData.customerID + '/parker/',
              querystring.stringify(temp),
              helper.createAxiosFormConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              response.data.sort((a,b) => b.id - a.id);
              let newlyInsertedParker = response.data.find(k => {
                // who the hell return every parker when call POST
                if(k['name'] === temp['name']
                && k['mobile'] === temp['mobile']
                && k['car1'] === temp['car1']
                && k['email'] === temp['email']
                ) {
                  return true;
                }
              })
              leaseData['parkerID'] = newlyInsertedParker['id'];
              return true;
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
            })
        ) {
          return;
        }
      }

      let temp = {}
      temp['licenseID'] = formData['licenseID'];
      temp['carparkID'] = formData['carparkID'];
      temp['customerID'] = this.pageLicense.find(k => helper.compareID(k.id, formData['licenseID']))['customerID'];
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).format('YYYY/MM/DD');
      temp['leases'] = JSON.stringify(formData['lease']);
      
      temp['operatorID'] = this.pageCarpark.find(k => helper.compareID(k.id, formData['carparkID'])).operatorID;

      let feedbackItem = 'parking license add-on application';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseAddon/create',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;

      let temp = {}
      temp['paymentPlan'] = formData['paymentPlan'];
      temp['commencementDate'] = helper.parseDateTime(formData['_commencementDate']).format('YYYY/MM/DD');
      temp['leases'] = JSON.stringify(formData['lease']);

      let feedbackItem = 'parking license add-on application';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseAddon/update',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      let url = this.$route.query.pending ? helper.WEB_URL + '/plAddOnPending' : helper.WEB_URL + '/plAddOn';
      if(window.location.href.includes('localhost')) {
        if(this.approvalAction === 'void') {
          // return;
        }
        location.reload();
        return;
      }
      helper.redirect({ path: url, query: { carparkID: this.$refs['pageForm'].formData['carparkID'] }});
    },

    async onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'applicationType') {
        this.$refs['pageFeedback'].setFeedbackError();
        this.$refs['pageForm'].formData['customerID'] = null;
        this.onApplicationTypeChange();
        this.hideFormFromKey('sectionApplicationInformation');
      } else if(formParameter.key === 'licenseID') {
        this.onLicenseChange();
      } else if(formParameter.key === 'customerID') {
        // if(formData[formParameter.key] === '-1') {
        //   if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
        //     helper.redirect({ path: helper.WEB_URL + '/personalForm', query: { redirect: 'plApplicationForm' }});
        //   } else {
        //     helper.redirect({ path: helper.WEB_URL + '/companyForm', query: { redirect: 'plApplicationForm' }});
        //   }
        //   return;
        // }

        // this.pageParker = null;

        // this.onApplicationCarparkOrProfileChange();
        // this.onApplicationCarparkTenantChange();
        // this.loadParker();
      } else if(formParameter.key === 'carparkID') {
        formData['licenseID'] = null;
        this.pageCarparkSeason = null;
        this.pageSeason = null;
        this.pageBay = null;

        this.onCarparkChange();
      } else if(formParameter.key === 'applicationCarparkTenant') {
        this.onApplicationCarparkTenantChange();
      } else if(formParameter.key === '_commencementDate') {
        formData.lease.forEach(leaseData => {
          leaseData['seasonFees'] = null;
        });
        this.onApplicationCarparkTenantChange();
        this.calculateParkingFees();
      } else if(formParameter.key === 'paymentPlan') {
        this.calculateParkingFees();
      }
    },

    onApplicationTypeChange() {
      // let formData = this.$refs['pageForm'].formData;
      // if(formData['applicationType'] === 'Personal') {
      //   PARAM_MAP['sectionCustomerProfile'].form_section = 'Personal Profile';
      //   PARAM_MAP['customerID'].text = 'Personal Full Name';
      //   helper.inputSelectSetOption(PARAM_MAP['customerID'], [].concat({id: -1, name: 'Create new personal profile'}, this.pageCustomer.filter(k => !k.isCompany) || []));
      //   this.$refs['pageTableLease'].setLeaseEnableAction(false, this.$refs['pageForm'].formIsAdd);
      //   if(formData['lease'].length > 1) {
      //     formData['lease'].splice(1);
      //   }
      // } else {
      //   PARAM_MAP['sectionCustomerProfile'].form_section = 'Company Profile';
      //   PARAM_MAP['customerID'].text = 'Company Name';
      //   helper.inputSelectSetOption(PARAM_MAP['customerID'], [].concat({id: -1, name: 'Create new company profile'}, this.pageCustomer.filter(k => k.isCompany) || []));
      //   this.$refs['pageTableLease'].setLeaseEnableAction(this.$refs['pageForm'].formIsAdd, this.$refs['pageForm'].formIsAdd);
      // }
    },
    onCarparkChange() {
      if(this.$refs['pageForm'].formIsAdd) {
        let formData = this.$refs['pageForm'].formData;

        let feedbackItem = 'car park setting';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.SERVER_URL + '/api2/carpark/' + formData['carparkID'] + '/seasonSetting/',
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            let result = response.data[0];
            if(!result) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park doesn't have valid setting.");
              this.hideFormFromKey('licenseID');
              return true;
            }
            if(result.SuspendApplication) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park has been suspended from Parking Application.");
              this.hideFormFromKey('licenseID');
              return true;
            }
            if(result.startDate && result.startDate > new moment().unix()) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park doesn't start operating until " + helper.formatDate(result.startDate));
              this.hideFormFromKey('licenseID');
              return true;
            }
            if(result.endDate && result.endDate < new moment().unix()) {
              this.$refs['pageFeedback'].setFeedbackError("Selected car park has stopped operating since " + helper.formatDate(result.endDate));
              this.hideFormFromKey('licenseID');
              return true;
            }
            this.$refs['pageFeedback'].setFeedbackMessage();

            // this.onApplicationCarparkOrProfileChange();
            // this.onApplicationCarparkTenantChange();
            // this.loadCarparkSeasonSetting();
            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
            this.hideFormFromKey('licenseID');
            return true;
          })
      } else {
        // this.onApplicationCarparkOrProfileChange();
        // this.onApplicationCarparkTenantChange();
        // this.loadCarparkSeasonSetting();
        this.loadLicense();
      }
    },
    onLicenseChange() {
      let formData = this.$refs['pageForm'].formData;
      formData['customerID'] = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], formData['licenseID']).customerID;
      this.pageParker = null;

      let customer = this.pageCustomer.find(k => helper.compareID(k.id, formData['customerID']));
      if(customer.isCompany) {
        this.$refs['pageTableLease'].setLeaseEnableAction(true, this.$refs['pageForm'].formIsAdd);
      } else {
        this.$refs['pageTableLease'].setLeaseEnableAction(false, this.$refs['pageForm'].formIsAdd);
      }

      this.onApplicationCarparkOrProfileChange();
      this.onApplicationCarparkTenantChange();
      this.loadParker();
    },
    onApplicationCarparkOrProfileChange() {
      let formData = this.$refs['pageForm'].formData;
      if(this.isTenant()) {
        PARAM_MAP['applicationCarparkTenant'].form_input_attr = {disabled : 1};
        formData['applicationCarparkTenant'] = 1;
      } else {
        PARAM_MAP['applicationCarparkTenant'].form_input_attr = null;
        formData['applicationCarparkTenant'] = 0;
      }
      // radio button won't update??
      // this.$refs['pageForm'].$forceUpdate();
    },
    onApplicationCarparkTenantChange() {
      if(this.pageSeason) {
        // if is old application then season might be missing after filter by enable and tenant
        if(!this.$refs['pageForm'].formIsAdd) {
          this.$refs['pageTableLease'].setSeasonData(this.pageSeason);
          return;
        }

        let formData = this.$refs['pageForm'].formData;
        // TODO kw1 entitle only product
        // TODO kw1 operator - public visible product
        let keepInSelection = helper.checkRoleIsParker() ? false : true;
        let allSeason = this.pageSeason.filter(k => {
          if(!k['isEnable']) {
            k['_disabled'] = 'Disabled'
            return keepInSelection;
          }
          if(k['startDate'] && helper.parseDateTime(k['startDate']) > helper.parseDateTime(formData['_commencementDate'])) {
            k['_disabled'] = 'Not Started'
            return keepInSelection;
          }
          if(k['stopDate'] && helper.parseDateTime(k['stopDate']) < helper.parseDateTime(formData['_commencementDate'])) {
            k['_disabled'] = 'Stopped'
            return keepInSelection;
          }
          if(k['isTenant']) {
            if(!parseInt(formData['applicationCarparkTenant'])) {
              k['_disabled'] = 'Tenant Only'
              return keepInSelection;
            }
          } else {
            if(parseInt(formData['applicationCarparkTenant'])) {
              k['_disabled'] = 'Non-tenant Only'
              return keepInSelection;
            }
          }
          if(!k['isPublic']) {
            if(helper.checkRoleIsParker()) {
              k['_disabled'] = 'Non-Public'
              return keepInSelection;
            }
          }
          if(k['entitleOnly']) {
            if(!formData['tenant']) {
              k['_disabled'] = 'Entitlement Only'
              return helper.checkRoleIsParker() ? false : keepInSelection;
            }
            
            let entitlement = this.pageEntitlement.find(j => 
              helper.compareID(j['seasonID'], k['id']) 
              && helper.compareID(j['tenantID'], formData['tenant']['id']))
            if(!entitlement || !entitlement.bayCount) {
              k['_disabled'] = 'Entitlement Unallocated'
              return keepInSelection;
            }

            let usedEntitlementBay = this.pageBay.filter(j => j.seasonID === k.id && j.leaseID && helper.compareID(j['customerID'], formData['customerID'])).length;
            k['_actualBayAvailable'] = entitlement.bayCount - usedEntitlementBay;
          } else {
            k['_actualBayAvailable'] = k['_bayAvailable'];
          }

          if(!k['_actualBayAvailable']) {
            k['_disabled'] = 'Insufficient Bay' 
            return true;
            return keepInSelection;
          }
          
          k['_disabled'] = null;
          return true;
        });

        this.$refs['pageTableLease'].setSeasonData(allSeason);

        // radio button will select both???
        // this.$refs['pageForm'].$forceUpdate();
      }

      if(!this.$refs['pageTableLease'].tableSeason || this.$refs['pageTableLease'].tableSeason.length === 0) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('No product available.');
      } else {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError();
      }
    },
    onApplicationLeaseSelect(leaseDataIndex, newSeasonID, oldSeasonID) {
      this.$refs['pageFeedback'].setFeedbackMessage();

      if(newSeasonID) {
        this.pageFees[newSeasonID] = this.pageFees[newSeasonID] || undefined;
      }

      let formData = this.$refs['pageForm'].formData;

      // cannot depend on leaseDataIndex because if delete lease on top will messed up
      // let temp = formData.lease.filter(k => k.tandemIndex !== leaseDataIndex);
      // formData.lease.splice(0);
      // temp.forEach(k => formData.lease.push(k));
      
      let selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, oldSeasonID)) || {};
      // if previsouly selected season is tandem reserved
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease[leaseDataIndex]['pairID'] = null;
        formData.lease.splice(leaseDataIndex + 1, selectedSeason['baySlots'] - 1);
      }

      selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, newSeasonID)) || {};
      // if newly selected season is tandem reserved
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease[leaseDataIndex]['pairID'] = new moment().valueOf();
        for(var i=1; i<selectedSeason['baySlots']; i++) {
          formData.lease.splice(leaseDataIndex + 1 , 0, { seasonID: selectedSeason.id, tandemIndex: leaseDataIndex, parkerID: null, pairID: formData.lease[leaseDataIndex]['pairID'] });
          // formData.lease.push({ seasonID: selectedSeason.id });
        }
      }

      if(this.pageCarparkSeason['ParkaideOnly']) {
        formData.lease.forEach(k => k['isParkAide'] = 1);
      }

      this.calculateParkingFees();
    },
    onApplicationLeaseRemove(leaseDataIndex, seasonID) {
      if(seasonID) {
        this.pageFees[seasonID] = this.pageFees[seasonID] || undefined;
      }

      let formData = this.$refs['pageForm'].formData;
      let selectedSeason = this.pageSeason.find(k => helper.compareID(k.id, seasonID));
      // if selected season is tandem reserved
      if(helper.compareID(selectedSeason['bayType'], 3)) {
        formData.lease.splice(leaseDataIndex, selectedSeason['baySlots'] - 1);
      }
      this.calculateParkingFees();
    },

    onApplicationApproveClick() {
      this.approvalAction = 'approve';
      this.approvalText = 'Approve parking license application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Approve Application');
    },
    onApplicationRejectClick() {
      this.approvalAction = 'reject';
      this.approvalText = 'Reject parking license application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectLabel = 'Reason of Reject';
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Reject Application');
    },
    onApplicationPendingClick() {
      this.approvalAction = 'pending';
      this.approvalText = 'Pending parking license application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Pending Application');
    },
    onApplicationVoidClick() {
      this.approvalAction = 'void';
      this.approvalText = 'VOID parking license application ' + this.pageApplication;
      this.approvalReject = true;
      this.approvalRejectLabel = 'Reason to VOID';
      this.approvalRejectReason = '';
      this.approvalRejectReasonError = '';
      this.$refs['pageApprovalModal'].setModalOpen(false, 'VOID Application');
    },
    onApplicationPaidClick() {
      this.approvalAction = 'complete';
      this.approvalText = 'Complete parking license application ' + this.pageApplication;
      this.approvalReject = false;
      this.$refs['pageApprovalModal'].setModalOpen(false, 'Complete Application');
    },
    pageApprovalModalConfirm() {
      if(this.approvalAction === 'reject') {
        if(!this.approvalRejectReason) {
          this.approvalRejectReasonError = 'Reason of Reject cannot be empty';
          return;
        } else {
          this.approvalRejectReasonError = '';
        }
      }

      this.updateApplicationStatus(this.approvalAction);
    },
    updateApplicationStatus(action) {
      this.approvalNotLoading = false;
      this.$refs['pageApprovalModal'].setModalClose('');

      let formData = this.$refs['pageForm'].formData;

      formData['rejectReason'] = this.approvalRejectReason;

      let feedbackItem = 'parking license add-on application ' + this.pageApplication + ' status';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseAddon/' + action,
          querystring.stringify({
            leases: JSON.stringify(formData['lease']),
            rejectReason: this.approvalRejectReason,
            account: JSON.parse(localStorage.getItem('user')).username,
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.approvalNotLoading = true;
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      return this.pageIsAdd ? helper.hasAddPermission(this.permission) : helper.hasEditPermission(this.permission);
    },
    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasApprovePermission() {
      return helper.hasPermission(this.permission + '.approve', false);
    },
    hasRejectPermission() {
      return helper.hasPermission(this.permission + '.reject', false);
    },
    hasVoidPermission() {
      return helper.hasPermission(this.permission + '.void', false);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLAddOnForm2.vue